<template>
  <DatePicker
    v-model="datePickerInput"
    @selected="dateSelected"
    :format="'yyyy-MM-dd'"
    :disabled-dates="{ customPredictor: predictDisabledDates }"
  />
</template>

<script>
import DatePicker from '@sum.cumo/vue-datepicker'
import '@sum.cumo/vue-datepicker/dist/Datepicker.css'
import { timeHelpers } from "../../helpers/timeHelpers";

const DateType = { type: [String, Boolean], default() { return false; } }

export default {
  components: { DatePicker },
  props: {
    days: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: String,
      default() {
        return '';
      }
    },
    startAt: DateType,
    endAt: DateType
  },
  watch: {
    value () {
      if (!this.value) {
        return;
      }
      this.datePickerInput = new Date(`${this.value}T13:00:00`);
    }
  },
  data() {
    return {
      datePickerInput: ''
    }
  },
  computed: {
    _days() {
      return this.days.map(d => timeHelpers.fromDateFormat(d));
    },
    _startAt() {
      return timeHelpers.fromDateFormat(this.startAt)
    },
    _endAt() {
      return timeHelpers.fromDateFormat(this.endAt)
    }
  },
  name: "LabDatePicker",
  methods: {
    predictDisabledDates(date) {
      if (!this.endAt && !this.startAt) {
        const days = this._days.filter(
          d => {
            return timeHelpers.onSameDay(date, d);
          }
        );
        return days.length < 1;
      }

      if (!timeHelpers.betweenDates(this._startAt, this._endAt, date)) {
        return true;
      }

      return this._days.some(d => timeHelpers.onSameDay(date, d));
    },
    dateSelected(date) {
      this.datePickerInput = date;
      this.$emit('input', date ? this.$moment(date, this.$moment.defaultFormat).format("YYYY-MM-DD") : '');
    }
  }
}
</script>

<style scoped>

</style>
